module.exports = __webpack_public_path__ + "static/media/18.87e5c0ef.jpg";